import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0.363762 6.6675C0.682425 3.36987 3.44074 0.786443 6.761 0.670258C10.5507 0.536986 13.6654 3.56124 13.6654 7.31336C13.6654 7.74393 13.6242 8.16425 13.5454 8.57432C13.5454 8.57432 13.5317 8.6495 13.5009 8.78277C13.3981 9.24409 13.2473 9.68492 13.052 10.1018C12.3804 11.6874 10.8351 14.3289 7.36749 17.1994C7.15162 17.3771 6.83981 17.3771 6.62737 17.1994C3.15977 14.3255 1.61443 11.684 0.946264 10.1052C0.754381 9.68833 0.60019 9.24409 0.497395 8.78618C0.463131 8.64949 0.452851 8.57773 0.452851 8.57773C0.336351 7.96605 0.298659 7.32703 0.363762 6.6675ZM9.77895 6.61309C10.0718 6.3202 10.0718 5.84533 9.77895 5.55243C9.48605 5.25954 9.01118 5.25954 8.71829 5.55243L6.24862 8.0221L5.27895 7.05243C4.98605 6.75954 4.51118 6.75954 4.21829 7.05243C3.92539 7.34533 3.92539 7.8202 4.21829 8.11309L5.71829 9.61309C6.01118 9.90599 6.48605 9.90599 6.77895 9.61309L9.77895 6.61309Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}